import axios from 'axios';
import qs from 'qs';

// 全局变量，用于标记是否已经弹出过超时提示
let hasShownTimeoutAlert = false;

import { vm } from '../main.js';

function normalizeResponse (data) {
	if (data == null) return data
	if (data.code !== undefined) return data
	if (data.header && data.header.ret !== undefined) {
		const ret = data.header.ret
		const ok = ret === '0' || ret === 0
		return {
			code: ok ? 200 : 500,
			msg: data.header.msg,
			data: data.data,
			header: data.header
		}
	}
	return data
}

function normalizeError (response, error) {
	if (response && response.data) {
		const data = response.data
		if (data.code !== undefined) return data
		if (data.header && data.header.ret !== undefined) {
			return normalizeResponse(data)
		}
		return {
			code: response.status,
			msg: data.msg || data.error || data.message || '请求失败'
		}
	}
	if (!window.navigator.onLine) {
		return { code: 0, msg: '网络不可用' }
	}
	return { code: -1, msg: error.message || '请求失败' }
}

//根据环境变量区分接口的默认地址
console.log(process.env.NODE_ENV,'process.env.NODE_EVN');
console.log('VUE_APP_BASE_API', process.env.VUE_APP_BASE_API);

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
// 设置超时时间和跨域是否允许携带凭证
// axios.defaults.timeout = 10000; //10s
axios.defaults.timeout = -1; //10s
axios.defaults.withCredentials = false; //是否允许携带凭证

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';   //get请求处理
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';   //post请求处理
// axios.defaults.transformRequest = data => qs.stringify(data);   //post请求处理

// axios.defaults.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8';   //post请求处理

//设置请求拦截器
axios.interceptors.request.use(config => {
	const url = config.url
	if (!url || url === '/' || url.trim() === '') {
		return Promise.reject(new Error('Invalid request url: empty path'))
	}
    config.url === '/uploadUtil' && (config.headers['content-type'] = 'multipart/form-data;charset=UTF-8');
	// config.url == '/uploadUtil' && (config.headers['Content-Type'] = false);

	let token = JSON.parse(localStorage.getItem('lifeData'))?.vuex_token
	token && (config.headers.Authorization = 'Bearer '+token)

	// 上传文件时 data 为 FormData：必须删除全局默认的 application/json，
	// 让浏览器自动补上 multipart/form-data; boundary=...，
	// 否则后端收到 application/json + multipart 体，报 "Current request is not a multipart request"
	if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
		delete config.headers['Content-Type']
		delete config.headers['content-type']
	}
	return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截器
 * */
// axios.defaults.validateStatus = status =>{
//     // 自定义响应成功的HTTP状态码
//     return /^(2|3)\d{2}$/.test(status))
// }
axios.interceptors.response.use(response => {

	if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
		return response.data
	}

	if (response.data && response.data.code === 401) {
        if (!hasShownTimeoutAlert) {
            hasShownTimeoutAlert = true;
            vm.$alert('登录已过期,请重新登录', '', {
                confirmButtonText: '确定',
                showClose: false,
                type: 'error',
                callback: action => {
                    hasShownTimeoutAlert = false;
                    vm.$router.replace('/login')
                }
            });
        }
        return response.data
	}

	if (response.data != null) {
		return normalizeResponse(response.data)
	}

	return { code: -1, msg: '响应数据为空' }


}, error => {
	const normalized = normalizeError(error.response, error)
	// HTTP 401：登录已过期/未登录，与成功分支保持一致，弹窗后跳登录页
	if (normalized && (normalized.code === 401 || (error.response && error.response.status === 401))) {
		if (!hasShownTimeoutAlert) {
			hasShownTimeoutAlert = true;
			vm.$alert('登录已过期,请重新登录', '', {
				confirmButtonText: '确定',
				showClose: false,
				type: 'error',
				callback: action => {
					hasShownTimeoutAlert = false;
					vm.$router.replace('/login')
				}
			});
		}
	}
	return normalized
})

export default axios
